import { useCallback } from 'react';
import type { AnalyticsGuidesDashboard } from '@/types/analytics/dashboard';
import { getGuidesDashboard } from '@/services/analytics/dashboard.service';
import { useAnalyticsSection } from './use-analytics-section';

const EMPTY: AnalyticsGuidesDashboard = {
  publishedCount: 0,
  totalViews: 0,
  viewsToday: 0,
  viewsMonth: 0,
  bestCtrLabel: '—',
  bestCtrTitle: '—',
  avgReadLabel: '—',
  viewsTrend: null,
  topGuides: [],
  guides: [],
  recentlyPublished: [],
  recentlyUpdated: [],
};

export function useAnalyticsGuides() {
  const loader = useCallback(() => getGuidesDashboard(), []);
  return useAnalyticsSection(loader, EMPTY);
}
